const config = {
    appId: 'wx30da4e5ca51b3768',
    baseURL: 'https://szdentistyang.com/dentist',
    openid: 'otlcK41p4zH4EKtOtl236XySd5UM'
}

export default config